import React, { useMemo } from 'react'
import { useChannelStateContext, useChatContext } from 'stream-chat-react'
import { ReactComponent as MessageEmptyIcon } from 'assets/svgs/message-empty.svg'
import type { StreamChatGenerics } from 'components/Chat/types'
import { isGroupChannel } from 'components/Chat/utils/channelHelpers'

export const MessageEmptyState: React.FC = () => {
  const { channel } = useChannelStateContext<StreamChatGenerics>()
  const { client } = useChatContext<StreamChatGenerics>()

  const displayName = useMemo(() => {
    if (!channel || !client?.user?.id) {
      return 'your team'
    }

    const members = Object.values(channel.state.members || {}).filter(
      (member) => member.user?.id !== client.user?.id
    )

    // Check if it's a 1-1 chat (not a group)
    if (!isGroupChannel(channel)) {
      const member = members[0]
      // Return first name for 1-1 chat
      return member?.user?.firstName || member?.user?.name || 'this conversation'
    }

    // For group chat, use channel name
    return channel.data?.name || 'this conversation'
  }, [channel, client?.user?.id])

  return (
    <div className="h-full flex flex-col items-center justify-center bg-app-white-100 px-6">
      <div className="max-w-md text-center">
        {/* Message Empty Icon */}
        <div className="mb-6 flex justify-center">
          <MessageEmptyIcon className="w-[124px] h-[124px]" />
        </div>

        {/* Welcome Message */}
        <h2 className="text-lg font-medium text-app-black-100">
          Start a conversation and connect with {displayName}!
        </h2>
      </div>
    </div>
  )
}
